module.exports = __webpack_public_path__ + "6abe87ff80cf5f499fce4da3df0d7d8c.glb";